import { Dispatch, SetStateAction, useCallback, useState } from 'react';

export enum StorageKey {
  ModernUI = 'modern-ui',
  Language = 'language',
  DateFormat = 'date-format',
  TimeFormat = 'time-format',
  SidebarCollapsed = 'sidebar-collapsed',
  AdminSidebarCollapsed = 'admin-sidebar-collapsed',
  AdminAgent = 'admin-agent',
  AdminClientNotes = 'admin-client-notes',
  AdminPanelRailPosition = 'admin-panel-rail-position',
}

export const usePersistedState = <T>(
  value: T,
  key: StorageKey
): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState<T>(() => {
    try {
      const persistedState = localStorage.getItem(key);
      return JSON.parse(persistedState || '') ?? value;
    } catch {
      return value;
    }
  });

  const setPersistedState: Dispatch<SetStateAction<T>> = useCallback(
    newValue => {
      setState(prevState => {
        const newState =
          typeof newValue === 'function' ? (newValue as (prev: T) => T)(prevState) : newValue;

        localStorage.setItem(key, JSON.stringify(newState));
        return newState;
      });
    },
    [key]
  );

  return [state, setPersistedState];
};
